<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/studyabroad' }"
        >升学规划</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/studyabroad' }"
        >留学调研</el-breadcrumb-item
      >
      <el-breadcrumb-item>出国留学调研问卷</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="title">出国留学调研问卷</div>
          <div class="covering">
            为了更好滴对国际教育升学方向的指导，需要对您初步做一个问卷调查，请您认真填写：
          </div>
        </div>
        <div class="btn">
          <div class="subject">
            <div class="left_subject">一</div>
            <div class="right_subject">
              <div class="info">基本信息</div>
              <div class="info_title">姓名：{{ userInfo }}</div>
              <!-- <div class="info_title">性别：{{ userInfo.gender }}</div>
              <div class="info_title">年级：{{ userInfo.studyYears }}</div>
              <div class="info_title">班级：{{ userInfo.className }}</div> -->
              <div class="info_title checkboxs">
                {{ list[0].busScaleStudies[0].name }}：
                <el-radio v-model="a.radio" label="1">是</el-radio>
                <el-radio v-model="a.radio" label="2">否</el-radio>
              </div>
              <div class="info_title" v-if="a.radio == '1'">
                {{ list[0].busScaleStudies[1].name }}：
                <el-checkbox-group v-model="a.list">
                  <el-checkbox
                    v-for="(it, index) in list[0].busScaleStudies[1].answer"
                    :key="index"
                    :label="it.name"
                  ></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div class="subject1">
            <div class="left_subject">二</div>
            <div class="right_subject">
              <div class="info">留学意向</div>
              <div class="info_title">
                {{ list[1].busScaleStudies[1].name }}
                <el-checkbox-group v-model="b.list">
                  <el-checkbox
                    v-for="(it, index) in list[1].busScaleStudies[1].answer"
                    :key="index"
                    :label="it.name"
                  ></el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="info_title checkboxs">
                {{ list[1].busScaleStudies[2].name }}
                <el-radio v-model="c.radio" label="1">是</el-radio>
                <el-radio v-model="c.radio" label="2">否</el-radio>
              </div>
              <div class="info_title" v-if="c.radio == '1'">
                <div class="aa">{{ list[1].busScaleStudies[3].name }}</div>
                <div class="rr">
                  <div class="atop">
                    <div class="top1">
                      <div class="one">1</div>
                      <div class="y">英语方向</div>
                    </div>
                    <el-checkbox-group v-model="c.EnglishList">
                      <el-checkbox
                        v-for="(it, index) in list[1].busScaleStudies[0].answer"
                        :key="index"
                        :label="it.name"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="atop">
                    <div class="top1">
                      <div class="one">2</div>
                      <div class="y">小语种方向</div>
                    </div>
                    <el-checkbox-group v-model="c.minorityList">
                      <el-checkbox
                        v-for="(it, index) in list[1].busScaleStudies[4].answer"
                        :key="index"
                        :label="it.name"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subject3">
            <div class="left_subject">三</div>
            <div class="right_subject">
              <div class="info">学习状态</div>
              <div class="info_title">
                <div>{{ list[2].busScaleStudies[0].name }}</div>
                <div class="ms">
                  <div>
                    <el-radio v-model="d.radio" label="1">是</el-radio>
                    <el-radio v-model="d.radio" label="2">否</el-radio>
                  </div>
                  <div v-if="d.radio == '1'">
                    描述偏科情况：<input v-model="d.value" class="inp" />
                  </div>
                </div>
              </div>
              <div class="info_title">
                <div>{{ list[2].busScaleStudies[1].name }}</div>
                <div class="ms">
                  <div>
                    <el-radio v-model="e.radio" label="1">是</el-radio>
                    <el-radio v-model="e.radio" label="2">否</el-radio>
                  </div>
                  <div v-if="e.radio == '1'">
                    计划情况：<input v-model="e.value" class="inp" />
                  </div>
                </div>
              </div>
              <div class="info_title">
                <div>{{ list[2].busScaleStudies[2].name }}</div>
                <div class="ms">
                  <div>
                    <el-radio v-model="f.radio" label="1">是</el-radio>
                    <el-radio v-model="f.radio" label="2">否</el-radio>
                  </div>
                  <div v-if="f.radio == '1'">
                    目标院校：<input v-model="f.value" class="inp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subject4">
            <div class="left_subject">四</div>
            <div class="right_subject">
              <div class="info">性格分析</div>
              <div class="info_title">
                <div>{{ list[3].busScaleStudies[0].name }}</div>
                <div class="ms">
                  <div>
                    <el-radio v-model="g.radio" label="1">是</el-radio>
                    <el-radio v-model="g.radio" label="2">否</el-radio>
                  </div>
                  <div v-if="g.radio == '1'">
                    兴趣爱好：<input v-model="g.value" class="inp" />
                  </div>
                </div>
              </div>
              <div class="info_title">
                <div>{{ list[3].busScaleStudies[1].name }}</div>
                <div class="ms">
                  <div>
                    <el-radio v-model="h.radio" label="1">是</el-radio>
                    <el-radio v-model="h.radio" label="2">否</el-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="but"><button @click="submit()">提交</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getbusscalestudy, CustomBusScale } from "@/api/home";
import { GetCustomerInfoById } from "@/api/user";

export default {
  name: "XSpecialentrance",

  data() {
    return {
      radio: "1",
      checkList: [],
      list: "",
      userInfo: "",
      usb: {
        CustomId: "",
        ScaleId: "340507046379589",
        Inputs: [],
      },
      a: {
        name: "是否选科",
        radio: "",
        list: [],
      },
      b: {
        name: "感兴趣的语种（可多选）",
        radio: "3",
        list: [],
      },
      c: {
        name: "是否考虑过出国留学",
        radio: "",
        EnglishList: [],
        minorityList: [],
      },
      d: {
        name: "是否存在偏科",
        radio: "",
        value: "",
      },
      e: {
        name: "是否会进行长期或短期的计划",
        radio: "",
        value: "",
      },
      f: {
        name: "是否有目标院校",
        radio: "",
        value: "",
      },
      g: {
        name: "是否有自己的兴趣爱好",
        radio: "",
        value: "",
      },
      h: {
        name: "是否有自己的兴趣爱好",
        radio: "",
      },
    };
  },

  async mounted() {
    const res = await getbusscalestudy("340507046379589");
    this.list = res.data || res.result;
    this.getUserInfo();
    this.usb.CustomId = this.$store.state.user.tenantId;
  },

  methods: {
    // 获取个人信息
    async getUserInfo() {
      const res = await GetCustomerInfoById();
      this.userInfo = res.result.nickName;
      sessionStorage.setItem("setStudentInfo", JSON.stringify(res.data.result));
    },
    submit() {
      setTimeout(() => {
        this.usb.Inputs.push(
          this.a,
          this.b,
          this.c,
          this.d,
          this.e,
          this.f,
          this.g,
          this.h
        );
        var that = this;
        let flag = that.usb.Inputs.every((item) => !!item.radio);
        if (!flag) {
          console.log("score分数不能为空！");
          this.usb.Inputs = [];
          this.$message.error("单选必须勾选哦~");
          return;
        } else {
          //不为空时执行的结果
          CustomBusScale({ ...this.usb });
          this.$message.success("提交成功");
          this.usb.Inputs = [];
          this.$router.push("/succeed");
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.box {
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
  .content {
    width: 100%;
    .top {
      width: 98%;
      height: 86px;
      border-radius: 3px 3px 3px 3px;
      background-color: #fff;
      padding: 17px 0 0 33px;
      margin-bottom: 32px;
      .title {
        padding-bottom: 14px;
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }
      .covering {
        width: 96%;
        font-size: 14px;
        line-height: 30px;
        color: #666;
      }
    }
    .btn {
      position: relative;
      width: 100%;
      height: 1500px;
      box-sizing: border-box;
      border-radius: 3px 3px 3px 3px;
      background-color: #fff;
      padding: 29px 0 0 47px;
      .subject {
        height: 250px;
        width: 96%;
        display: flex;
        align-items: top;
        border-bottom: 1px dashed #666;
        .left_subject {
          width: 20px;
          height: 20px;
          background: #3964e6;
          border-radius: 50%;
          opacity: 1;
          color: #fff;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
        }
        .right_subject {
          font-size: 14px;
          .info {
            font-weight: bold;
            margin-bottom: 20px;
          }
          .info_title {
            margin-top: 10px;
            display: flex;
          }
        }
      }
      .subject1 {
        height: 250px;
        width: 96%;
        display: flex;
        align-items: top;
        border-bottom: 1px dashed #666;
        margin-top: 40px;
        .left_subject {
          width: 20px;
          height: 20px;
          background: #3964e6;
          border-radius: 50%;
          opacity: 1;
          color: #fff;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
        }
        .right_subject {
          font-size: 14px;
          .info {
            font-weight: bold;
            margin-bottom: 20px;
          }
          .info_title {
            margin-top: 10px;
            display: flex;
            .atop {
              .top1 {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                .one {
                  width: 15px;
                  height: 15px;
                  background: #f99f39;
                  border-radius: 15px 15px 15px 15px;
                  opacity: 1;
                  border: 1px solid #f99f39;
                  border-radius: 50%;
                  color: #fff;
                  text-align: center;
                  line-height: 15px;
                }
                .y {
                  margin-left: 5px;
                  font-weight: bold;
                }
              }
            }
          }
          .info_title {
            margin-top: 10px;
            display: flex;
            .rr {
              .atop {
                margin-bottom: 20px;
                .top1 {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;
                  .one {
                    width: 15px;
                    height: 15px;
                    background: #f99f39;
                    border-radius: 15px 15px 15px 15px;
                    opacity: 1;
                    border: 1px solid #f99f39;
                    border-radius: 50%;
                    color: #fff;
                    text-align: center;
                    line-height: 15px;
                  }
                  .y {
                    margin-left: 5px;
                    font-weight: bold;
                  }
                }
              }
            }
          }
        }
      }
      .subject3 {
        height: 350px;
        width: 96%;
        display: flex;
        align-items: top;
        border-bottom: 1px dashed #666;
        margin-top: 40px;
        .left_subject {
          width: 20px;
          height: 20px;
          background: #3964e6;
          border-radius: 50%;
          opacity: 1;
          color: #fff;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
        }
        .right_subject {
          font-size: 14px;
          .info {
            font-weight: bold;
            margin-bottom: 20px;
          }
          .info_title {
            margin-top: 30px;
            .ms {
              margin-top: 10px;
              .inp {
                width: 500px;
                outline: none;
                border-color: #666;
                border-style: solid;
                border-top-width: 0px;
                border-right-width: 0px;
                border-bottom-width: 1px;
                border-left-width: 0px;
              }
            }
          }
        }
      }
      .subject4 {
        height: 350px;
        width: 96%;
        display: flex;
        align-items: top;
        margin-top: 40px;
        .left_subject {
          width: 20px;
          height: 20px;
          background: #3964e6;
          border-radius: 50%;
          opacity: 1;
          color: #fff;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
        }
        .right_subject {
          font-size: 14px;
          .info {
            font-weight: bold;
            margin-bottom: 20px;
          }
          .info_title {
            margin-top: 30px;
            .ms {
              margin-top: 10px;
              .inp {
                width: 500px;
                outline: none;
                border-color: #666;
                border-style: solid;
                border-top-width: 0px;
                border-right-width: 0px;
                border-bottom-width: 1px;
                border-left-width: 0px;
              }
            }
          }
        }
      }
      .but {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        button {
          cursor: pointer;
          width: 63px;
          height: 31px;
          background: #3964e6;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 0;
          color: #fff;
        }
      }
    }
  }
}
</style>
